import React from 'react'

import withRootContext from 'context/withRootContextHOC'
import { useServiceScheduleContext, actionTypes } from '../../../context/serviceScheduleContext'

import PageContainer from 'src/components/pageContainer'
import WarningModal from 'src/components/warningModal'
import { Radio } from 'src/components/forms'

import FormSteps from 'src/components/formSteps'
import Alert from 'src/components/alert'

import { PAYMENT_TYPES } from './constants'

import { assetPrefix } from 'src/config/env_config'

import * as S from './styles'
import * as Gs from 'src/styles/global'

const HowToPayStep = (props) => {
  const { context } = props
  const { state, dispatch, functions: { handleWarningModalClose } } = useServiceScheduleContext()
  const { scheduleBody, error, modal } = state

  const handleSelectPaymentType = async (paymentType) => {
    dispatch({
      type: actionTypes.UPDATE_STATE,
      payload: {
        scheduleBody: {
          ...scheduleBody,
          paymentType
        },
        error: { ...error }
      }
    })
  }

  return (
    <PageContainer>
      <FormSteps context={context} finalStep HowToPayStep>
        <S.PageContainer>
          <Gs.WrapperFormAndCard>
            <S.WrapperForm>
              <S.AlignWrappers>
                <S.WrapperTitle>
                  <span>Escolha como pagar</span>
                </S.WrapperTitle>
                <S.WrapperElements>
                  {PAYMENT_TYPES.map((paymentType, index) => {
                    const { type, title, subTitle, icon } = paymentType
                    const isPaymentTypeSelected = type === scheduleBody.paymentType
                    return <S.WayCard
                      key={`${index}-${type}`}
                      onClick={() => handleSelectPaymentType(
                        type
                      )}
                      selected={isPaymentTypeSelected}
                      active
                    >
                      <S.Container>
                        <S.Photo noBorder src={icon} />
                        <S.TextInfo>
                          <span>{title}</span>
                          <span>{subTitle}</span>
                        </S.TextInfo>
                      </S.Container>
                      <S.ServiceOption>
                        <Radio name='howToPay' defaultChecked={isPaymentTypeSelected} />
                      </S.ServiceOption>
                    </S.WayCard>
                  })}
                  <Alert
                    show
                    margin='0'
                  >
                    <S.AlertTitle>Assinante Pacote de Serviços</S.AlertTitle>
                    <S.AlertContent>
                      Se você tem um plano ativo, siga com "Pagamento no local". Caso inclua serviços adicionais não cobertos pelo plano, você poderá pagar a diferença na hora.
                    </S.AlertContent>
                  </Alert>
                </S.WrapperElements>
              </S.AlignWrappers>
            </S.WrapperForm>
          </Gs.WrapperFormAndCard>
        </S.PageContainer>
      </FormSteps>

      <WarningModal
        visible={!!modal}
        cancelLabel={modal?.cancelLabel}
        confirmLabel={modal?.confirmLabel}
        type={modal?.type}
        title={modal?.title}
        subtitle={modal?.subtitle}
        onConfirm={modal?.onConfirm}
        onCancel={modal?.onCancel || handleWarningModalClose}
        fullButton={modal?.fullButton}
        outlineCancelButton={modal?.outlineCancelButton}
        showClose={modal?.showClose}
        icon={modal?.icon ? modal?.icon : !modal?.professional ? `${assetPrefix}/static/icons/warning.svg` : ''}
        iconSize={modal?.iconSize}
        dataTest='modal-warning-scheduling'
      >
        {modal?.body}
      </WarningModal>
    </PageContainer>
  )
}

export default withRootContext(HowToPayStep)
